import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import { putDoubleFactorUpdate, putLoginUpdate, putValidateSecurityCredentials } from "../../../../../api";
import { formatValidationDate, validateEmail, validatePhone } from "../../../../../utils/utils";
import {
  ACCORDION_USER_DFA_LOGIN,
  CREDENTIALS_TYPE_EMAIL,
  CREDENTIALS_TYPE_LOGIN,
  CREDENTIALS_TYPE_PHONE,
  MESSAGE_USER_DFA_UPDATE,
  MESSAGE_USER_LOGIN_UPDATE,
  MESSAGE_USER_LOGIN_VALIDATE,
} from "../../../../../utils/constants";
import Accordion from "@material-ui/core/Accordion";
import { AccordionSummary } from "@material-ui/core";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import AlertDialog from "../../../../../components/custom-dialog/CustomDialogComponent";
import Tooltip from "@material-ui/core/Tooltip";
import { useIntl } from "react-intl";

const DFALoginComponent = ({ classes, id, user, idCrm, handleGetUser, expanded, handleSetExpanded }) => {
  const intl = useIntl();

  const [credential, setCredential] = useState("");
  const [login, setLogin] = useState("");
  const [openInfo, setOpenInfo] = useState(false);

  useEffect(() => {
    if (user?.idLogin) {
      if (validateEmail(user?.idLogin)) {
        setCredential(CREDENTIALS_TYPE_EMAIL);
      } else if (validatePhone(user?.idLogin)) {
        setCredential(CREDENTIALS_TYPE_PHONE);
      } else {
        setCredential(CREDENTIALS_TYPE_LOGIN);
      }
    }

    if (user?.idLogin) {
      setLogin(user.idLogin);
    }
  }, [user]);

  const handleSetLogin = (value) => {
    setLogin(value?.toUpperCase());
  };

  const handleRestoreLogin = () => {
    setLogin(user?.idLogin);
  };

  const handleUpdateDfaStatus = () => {
    const body = { dobleFactorActivo: !user?.dobleFactorActivado };
    putDoubleFactorUpdate(idCrm, id, body, handleGetUser, { id: MESSAGE_USER_DFA_UPDATE });
  };

  const handleValidateLogin = () => {
    const body = {
      tipoCredencial: CREDENTIALS_TYPE_LOGIN,
      credencial: login,
    };

    putValidateSecurityCredentials(idCrm, id, body, handleGetUser, {
      id: MESSAGE_USER_LOGIN_VALIDATE,
      options: { idLogin: user.idLogin },
    });
  };

  const handleUpdateLogin = () => {
    const body = { nuevoLogin: login };
    putLoginUpdate(idCrm, id, body, handleGetUser, {
      id: MESSAGE_USER_LOGIN_UPDATE,
      options: { idLogin: login },
    });
  };

  const handleOpenInfo = (e) => {
    e.preventDefault();
    setOpenInfo((openInfo) => !openInfo);
  };

  const InfoModalContent = () => {
    return <Typography dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "custom.info.dfa_login" }) }} />;
  };

  return (
    <>
      <Accordion expanded={!!expanded.includes(ACCORDION_USER_DFA_LOGIN)}>
        <AccordionSummary aria-controls="panel1bh-content" id="panel1bh-header">
          <div className={classes.accordionHeader}>
            <Typography
              onClick={() => handleSetExpanded(ACCORDION_USER_DFA_LOGIN)}
              className={classes.accordionTitle}
              variant={"h6"}
            >
              {intl.formatMessage({ id: "custom.user.dfa_login" })}
            </Typography>
            <Button startIcon={<InfoOutlinedIcon />} onClick={handleOpenInfo}>
              {intl.formatMessage({ id: "ra.action.more_info" })}
            </Button>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <Grid item xs={12} container spacing={4}>
            <Grid item xs={12} container spacing={4} justifyContent={"space-between"}>
              <Grid item xs={12} sm={12} md={12} lg={6}>
                <TextField
                  disabled
                  //disabled={!user}
                  label={intl.formatMessage({ id: "custom.user.login_id" })}
                  value={login}
                  variant="outlined"
                  onChange={(e) => handleSetLogin(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={intl.formatMessage({ id: "custom.user.tooltip_validate_login" })}
                >
                  <span>
                    <Button
                      className={classes.button}
                      disabled={!!user?.fechaValidacionIdLogin || !user?.idLogin}
                      startIcon={<CheckCircleOutlineOutlinedIcon />}
                      onClick={handleValidateLogin}
                    >
                      {intl.formatMessage({ id: "ra.action.validate" })}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={intl.formatMessage({ id: "custom.user.tooltip_change_login" })}
                >
                  <span>
                    <Button
                      className={classes.button}
                      disabled
                      //disabled={login === user?.idLogin}
                      startIcon={<SaveOutlinedIcon />}
                      onClick={handleUpdateLogin}
                    >
                      {intl.formatMessage({ id: "ra.action.save" })}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2}>
                <Button
                  startIcon={<CancelOutlinedIcon />}
                  disabled={!login || login === user?.idLogin}
                  onClick={handleRestoreLogin}
                  className={classes.iconButton}
                >
                  {intl.formatMessage({ id: "ra.action.erase" })}
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={4}>
              <Grid item xs={4} className={classes.keyValue}>
                <Typography variant={"caption"}>{intl.formatMessage({ id: "custom.user.login_type" })}</Typography>
                <Typography>{credential ? intl.formatMessage({ id: `custom.user.${credential}` }) : "-"}</Typography>
              </Grid>
              <Grid item xs={4} className={classes.keyValue}>
                <Typography variant={"caption"}>
                  {intl.formatMessage({ id: "custom.user.login_validation" })}
                </Typography>
                <Typography>{formatValidationDate(user?.fechaValidacionIdLogin)}</Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} container spacing={4}>
              <Grid item xs={4} className={classes.keyValue}>
                <Typography variant={"caption"}>{intl.formatMessage({ id: "custom.dfa_status" })}</Typography>
                <Typography>
                  {!user
                    ? " - "
                    : intl.formatMessage({
                        id: user?.dobleFactorActivado ? "custom.dfa_status_activated" : "custom.dfa_status_deactivated",
                      })}
                </Typography>
              </Grid>
              <Grid item xs={8} sm={8} md={8} lg={3}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={intl.formatMessage({
                    id: user?.dobleFactorActivado
                      ? "custom.user.tooltip_deactivate_dfa"
                      : "custom.user.tooltip_activate_dfa",
                  })}
                >
                  <span>
                    <Button
                      className={classes.button}
                      disabled={!user}
                      startIcon={<VpnKeyOutlinedIcon />}
                      onClick={handleUpdateDfaStatus}
                    >
                      {intl.formatMessage({
                        id: user?.dobleFactorActivado ? "custom.dfa_status_deactivate" : "custom.dfa_status_activate",
                      })}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <AlertDialog
        openAlert={openInfo}
        handleClose={handleOpenInfo}
        title={intl.formatMessage({ id: "custom.user.dfa_login" })}
        cancelButtonText={intl.formatMessage({ id: "ra.action.close" })}
        content={<InfoModalContent />}
      />
    </>
  );
};

export default DFALoginComponent;
